import { brandStrong100, shade40 } from "@themes/colors";

export const DEFAULT_STROKE_WIDTH = 10;
export const DEFAULT_TRAIL_COLOR = shade40.withAlpha(0.4);
export const DEFAULT_PATH_COLOR = brandStrong100;
